<div class="content">
	<p class="p1" [translate]="keys().titleKey"></p>
	<p class="details">{{ keys().message }}</p>
</div>
<footer>
	<div class="buttons">
		<button class="sm cancel" (click)="ok()" stagesAutofocus translate="ok"></button>
	</div>
</footer>
